import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import t from '../../lib/I18n';
import Favourite from "../../records/Favourite";

import Icon from "../general/Icon";
import FareStations from "../checkout/FareStations";
import FareClassBadge from '../fares/FareClassBadge';

FavouriteDetails.propTypes = {
    favourite: PropTypes.instanceOf(Favourite),
};

export default function FavouriteDetails({ favourite }) {
    const isFlexi = favourite.ticketType.code === 'FL1';
    return (
        <Fragment>
            <h2 className="favourite-list__item__title">
                <FareClassBadge className="pull-left" isFirstClass={favourite.isFirstClass()} />
                <span className="pull-left">&nbsp;&nbsp;</span>
                <FareStations
                    forceFontWeight={false}
                    origin={favourite.origin}
                    destination={favourite.destination}
                    isReturn={favourite.isOpenReturn}
                />
            </h2>
            <h3 className="favourite-list__item__sub-title" title={favourite.ticketType.code}>
                {favourite.ticketType.name}{' '}
                {favourite.isTravelcard() && <Icon icon="londontravelcard" />}
            </h3>
            <div className="favourite-list__item__passengers">
                {t('booking.passengers.summary.text', {
                    adults: isFlexi ? favourite.passengerCount : favourite.adults,
                    children: favourite.children,
                })}
            </div>
            {favourite.hasRailcard() && (
                <ul className="favourite-list__item__railcards">
                    {favourite
                        .getRailcardCounts('name')
                        .entrySeq()
                        .map(([name, quantity]) => (
                            <li key={name}>{t('booking.railcardsCount', { quantity, name })}</li>
                        ))}
                </ul>
            )}
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/components/favourites/FavouriteDetails.js